import React from "react";
import { Button, Modal, Row, Col } from "react-bootstrap";
import {
  addContactAction,
  getContactByEmailAction,
  getUserRolesAction,
  addUserRolesAction,
  getUserRolesActionNew,
  addContactActionNew,
  CheckEmailOrMobileUnique,
  CheckEmailOrMobileUniqueatAddContact,
  addClientAction,
} from "../../actions/UserActions";
import { connect } from "react-redux";
import * as Yup from "yup";
import { Field, Form, Formik, ErrorMessage } from "formik";
import InputMask from "react-input-mask";
import {
  checkObjExists,
  cryptoTokenDecode,
  toastMessage,
} from "./../Common/Common";
import * as constant from "./../../config/Constants";
import * as message from "./../../config/CommonMessages";
import UrlConstants from "../../config/UrlConstants";
import APIUtil from "./../../config/APIUtil";
import { HexColorPicker } from "react-colorful";
class CreateContact extends React.Component {
  constructor(props) {
    super(props);
    let currentType = cryptoTokenDecode().roleName;
    this.state = {
      page: 1,
      isEmailValid: false,
      isRoleExist: false,
      unauthorized: false,
      mobileUnauthorized: false,
      showLoader: false,
      // Contact data that gets read into the system
      // Role and userType should be arrays
      contact: {
        email: "",
        role: "",
        usertype: message.VENDOR,
        firstname: "",
        lastname: "",
        mobileNumber: "",
        companyName: "",
        isTextMsgEnabled: false,
        ownerId:
          cryptoTokenDecode().usertype === message.ACCTOWNER
            ? localStorage.getItem("ID")
            : localStorage.getItem("ownerId"),
        color: "",
        allowPublicProfile: false,
        allowPublicScheduling: false,
      },
      saveType: "",
      role: "",
      sameContingency: false,
      currentRole: !!currentType ? currentType.toUpperCase() : "",
      allowPublicSchedulingErr: false,
      allowPublicProfileUrlErr: false,
    };
  }

  componentWillMount() {
    var userType = cryptoTokenDecode().usertype;

    let type = this.props.roleForPopup === "Artist" ? "Artist" : "Client";
    // console.log("type-62", type);
    if (
      userType === message.ADMIN ||
      (userType === message.VENDOR &&
        this.state.currentRole === message.BUYERAGENT)
    ) {
      this.props
        .getUserRolesActionNew("?id=" + this.props.transactionData.ownerId)
        .then((res) => {
          // console.log("this.props.roles", this.props.roles);
          this.props.roles.map((x) => {
            if (x.name == type) {
              this.setState({
                role: x._id,
              });
            }
          });
        });
    } else {
      this.props.getUserRolesActionNew().then((res) => {
        // console.log("this.props.roles", this.props.roles);
        this.props.roles.map((x) => {
          if (x.name == type) {
            this.setState({
              role: x._id,
            });
          }
        });
      });
    }
  }

  /**
   * @desc action on next button clicked
   * checking email is already exist or not
   * if email exist then load user's data to modal
   * if not exist then show empty form for contact details
   */
  // next(email, role, errors, setFieldError) {
  //   if (email !== "" && errors["email"] === undefined) {
  //     this.props.getContactByEmailAction(email).then((res) => {
  //       if (res === "Unauthorized") {
  //         this.setState({
  //           unauthorized: true,
  //         });
  //       } else {
  //         if (Object.keys(res).length > 0) {
  //           if (res.isDeleted && res.isDeleted === true) {
  //             this.setState({
  //               unauthorized: true,
  //             });
  //           } else {
  //             // Contact data being read into the system
  //             // Add conditionals to role array that maps user role to user type
  //             var contact = {
  //               role: res.role ? res.role[0] : "",
  //               usertype: message.VENDOR,
  //               firstname: res.firstname,
  //               lastname: res.lastname,
  //               mobileNumber: res.mobileNumber,
  //               email: email,
  //               companyName: !!res.companyInformation
  //                 ? res.companyInformation.name
  //                 : "",
  //             };
  //             this.setState({
  //               isEmailValid: true,
  //               unauthorized: false,
  //               isRoleExist: res.role ? true : false,
  //               contact,
  //             });
  //           }
  //         }
  //         this.setState({ page: 1 });
  //       }
  //     });
  //   }
  // }

  checkDsdData(res) {
    let ownerId =
      localStorage.getItem("usertype") === "VENDOR"
        ? localStorage.getItem("ownerId")
        : localStorage.getItem("ID");
    let foundOwner = {};
    if (res && res.dsd && res.dsd.studios && res.dsd.studios.length > 0) {
      foundOwner = res.dsd.studios.filter((item) => item.ownerId === ownerId);
    }
    return foundOwner;
  }

  checkDsdItemValue(foundOwner, item) {
    return foundOwner.hasOwnProperty(item) ? foundOwner[item] : false;
  }

  getExistingUserData(email, errors) {
    if (email !== "" && errors["email"] === undefined) {
      this.props.getContactByEmailAction(email).then((res) => {
        if (res === "Unauthorized") {
          this.setState({
            unauthorized: true,
          });
        } else {
          if (Object.keys(res).length > 0) {
            if (res.isDeleted && res.isDeleted === true) {
              this.setState({
                unauthorized: true,
              });
            } else {
              // Contact data being read into the system
              // Add conditionals to role array that maps user role to user type
              var contact = {
                email: email,
                role: this.state.role,
                usertype: message.VENDOR,
                firstname: res.firstname,
                lastname: res.lastname,
                mobileNumber: res.mobileNumber,
                companyName:
                  res.dsd &&
                  res.dsd.roles &&
                  res.dsd.roles.length > 0 &&
                  res.dsd.roles[0] &&
                  res.dsd.roles[0].companyInformation &&
                  res.dsd.roles[0].companyInformation.name
                    ? res.dsd.roles[0].companyInformation.name
                    : "",
                ownerId:
                  cryptoTokenDecode().usertype === message.ACCTOWNER
                    ? localStorage.getItem("ID")
                    : localStorage.getItem("ownerId"),
                color: res.color ? res.color : "",
                allowPublicProfile: !!this.checkDsdData(res)
                  ? this.checkDsdItemValue("allowPublicProfile")
                  : false,
                allowPublicScheduling: !!this.checkDsdData(res)
                  ? this.checkDsdItemValue("allowPublicScheduling")
                  : false,
              };
              this.setState({
                isEmailValid: true,
                unauthorized: false,
                mobileUnauthorized: false,

                // isRoleExist: this.state.role ? true : false,
                contact,
              });
            }
          } else {
            var contact = {
              email: email,
              role: "",
              usertype: message.VENDOR,
              firstname: "",
              lastname: "",
              mobileNumber: "",
              companyName: "",
              ownerId:
                cryptoTokenDecode().usertype === message.ACCTOWNER
                  ? localStorage.getItem("ID")
                  : localStorage.getItem("ownerId"),
              color: "",
              allowPublicProfile: false,
              allowPublicScheduling: false,
            };
            this.setState({
              page: 1,
              isEmailValid: false,
              isRoleExist: false,
              unauthorized: false,
              mobileUnauthorized: false,
              contact,
            });
          }
        }
      });
    }
  }

  /**
   * @desc add contact
   * check if user selected custom role then first add that role using api
   * and then add user/contact with details by add contact api
   */
  addContact(values) {


    // console.log("addContact values", values);
    var userType = cryptoTokenDecode().usertype;
    // console.log("userType", userType);
    if (userType === "VENDOR") {
      values["ownerId"] = localStorage.getItem("ownerId");
    }
    // console.log("values199", values);
    //trim the data
    values.email = values.email.trim();
    values.firstname = values.firstname.trim();
    values.lastname = values.lastname.trim();
    values.companyName = values.companyName ? values.companyName.trim() : "";

    if (values.color && values.color === "#NaNNaNNaN") {
      values.color = "";
    }

    if (this.props.transactionData) {
      values["ownerId"] = this.props.transactionData.ownerId;

      if (
        userType.toUpperCase() === message.VENDOR &&
        this.state.currentRole === message.BUYERAGENT
      ) {
        values["rolename"] = "ep";
      }
    }

    if (
      this.props.roleForPopup === "Client" &&
      values.isTextMsgEnabled === undefined
    ) {
      values["isTextMsgEnabled"] = false;
    }

    if (values.role === "other") {
      let userRoleData = {};
      userRoleData.name = values.other.toUpperCase();

      if (
        userType.toUpperCase() === message.ACCTOWNER ||
        (userType.toUpperCase() === message.VENDOR &&
          this.state.currentRole === message.BUYERAGENT)
      ) {
        userRoleData.ownerId = localStorage.getItem("ID");
      }
      if (
        userType === message.VENDOR &&
        this.state.currentRole === message.Artist
      ) {
        userRoleData.ownerId = localStorage.getItem("ownerId");
      }
      values.companyInformation = { name: values.companyName };
      delete values.companyName;

      this.props.addUserRolesAction(userRoleData).then((userRes) => {
        if (userRes.status === constant.OK) {
          values["roles"] = [userRes.data._id];
          values.mobileNumber = Number(values.mobileNumber);

          this.props.roleForPopup === "Artist"
            ? this.props.addContactActionNew(values).then((res) => {
                toastMessage(constant.SUCCESS, message.CONTACT_ADDED);
                this.props.onClose();
              })
            : this.props.addClientAction(values).then((res) => {
                toastMessage(constant.SUCCESS, message.CONTACT_ADDED);
                this.props.onClose();
              });
        } else if (userRes.status === constant.CONFLICT) {
          toastMessage(constant.ERROR, userRes.data);
          this.props.onClose();
        }
      });
    } else {
      // console.log("addContact else values.role", values.role);
      values["roles"] = [values.role];

      values.mobileNumber = Number(values.mobileNumber);
      values.email = values.email.toLowerCase();
      values.companyInformation = { name: values.companyName };
      delete values.companyName;

      // console.log("addContact else submit values", values);

      this.props.roleForPopup === "Artist"
        ? this.props.addContactActionNew(values).then((res) => {
            if (res.status === constant.FORBIDDEN) {
              this.setState({
                sameContingency: true,
              });
            } else if (res.status === constant.BAD_REQUEST) {
              toastMessage(constant.ERROR, res.data);
            } else {
              toastMessage(constant.SUCCESS, message.CONTACT_ADDED);
              this.props.onClose();
            }
          })
        : this.props.addClientAction(values).then((res) => {
            if (res.status === constant.FORBIDDEN) {
              this.setState({
                sameContingency: true,
              });
            } else if (res.status === constant.BAD_REQUEST) {
              toastMessage(constant.ERROR, res.data);
            } else {
              toastMessage(constant.SUCCESS, message.CONTACT_ADDED);
              this.props.onClose();
            }
          });
    }
    this.setState({
      showLoader: false,
    });
  }

  setFieldValue(name, e) {
    var contact = this.state.contact;
    contact[name] = e;
    this.setState({
      contact,
    });
  }

  setMobile(value, field, setFieldValue) {
    var mob = value.replace(/-/g, "");
    setFieldValue(field, mob);
  }

  checkValidationsAndSubmit(values, errors) {
    // console.log("values283", values);
    if (!this.state.isEmailValid) {
      //new contact adding
      this.setState({
        showLoader: true,
      });
      let mobile = values["mobileNumber"];
      let email = values["email"];

      APIUtil.getMethod(
        UrlConstants.addContact +
          "/CheckEmailOrMobileUniqueatregistration?mobile=" +
          mobile,
        false
      ).then((res) => {
        if (res.data.error === "Unauthorized") {
          this.setState({ mobileUnauthorized: true });
          this.setState({
            showLoader: false,
          });
        } else {
          this.setState({ mobileUnauthorized: false });
        }
        if (
          this.state.saveType !== "next" &&
          !this.state.mobileUnauthorized &&
          !this.state.allowPublicProfileUrlErr &&
          !this.state.allowPublicSchedulingErr
        ) {
          this.addContact(values);
        }
      });
    } else {
      //existing contact with new role adding
      if (
        this.state.saveType !== "next" &&
        !this.state.mobileUnauthorized &&
        !this.state.allowPublicProfileUrlErr &&
        !this.state.allowPublicSchedulingErr
      ) {
        this.setState({
          showLoader: true,
        });
        this.addContact(values);
      }
    }
  }

  checkPublicProfileUrl(values, setFieldValue, item, itemValue) {
    if (!values.allowPublicProfile) {
      if (itemValue) {
        this.setState({
          allowPublicSchedulingErr: true,
          allowPublicProfileUrlErr: false,
        });
      } else {
        setFieldValue(item, itemValue);
        this.setState({
          allowPublicSchedulingErr: false,
          allowPublicProfileUrlErr: false,
        });
      }
    } else {
      setFieldValue(item, itemValue);
      this.setState({
        allowPublicSchedulingErr: false,
        allowPublicProfileUrlErr: false,
      });
    }
  }

  checkPublicScheduling(values, setFieldValue, item, itemValue) {
    if (values.allowPublicScheduling) {
      if (!itemValue) {
        this.setState({
          allowPublicProfileUrlErr: true,
          allowPublicSchedulingErr: false,
        });
      } else {
        setFieldValue(item, itemValue);
        this.setState({
          allowPublicProfileUrlErr: false,
          allowPublicSchedulingErr: false,
        });
      }
    } else {
      setFieldValue(item, itemValue);
      this.setState({
        allowPublicProfileUrlErr: false,
        allowPublicSchedulingErr: false,
      });
    }
  }

  render() {
    return (
      <div>
        {this.state.showLoader && (
          <div className="page-loader fixed">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        )}
        <Modal.Body>
          <Formik
            validateOnBlur={true}
            initialValues={this.state.contact}
            enableReinitialize={true}
            validationSchema={Yup.object().shape({
              firstname: Yup.string()
                .trim()
                .required(message.ENTER_FIRST_NAME)
                .matches(new RegExp("^[A-Za-z '-]{1,50}$"), {
                  message: message.ENTER_VALID_FIRST_NAME,
                }),
              lastname: Yup.string()
                .trim()
                .required(message.ENTER_LAST_NAME)
                .matches(new RegExp("^[A-Za-z '-]{1,50}$"), {
                  message: message.ENTER_VALID_LAST_NAME,
                }),
              role: Yup.string(),
              email: Yup.string()
                .trim()
                .matches(
                  new RegExp("^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$"),
                  {
                    message: message.ENTER_VALID_EMAIL,
                  }
                )
                .required(message.ENTER_EMAIL),

              mobileNumber: Yup.string()
                .nullable()
                .required(message.ENTER_MOBILE_NUMBER)
                .test("mobileNumber", message.ENTER_VALID_MOBILE, (value) => {
                  if ((value || "").length === 10 && value.charAt(0) != "0") {
                    return true;
                  }
                  return false;
                }),
              isTextMsgEnabled: Yup.boolean(),
            })}
            onSubmit={(values, errors) => {
              values.role = this.state.role;
              this.checkValidationsAndSubmit(values, errors);
              // if (this.state.saveType !== "next") {
              //   this.addContact(values);
              // }
            }}
          >
            {({ handleChange, values, errors, setFieldValue }) => (
              <Form className="form-sm form-admin">
                {/* {this.state.page === 0 && (
                  <>
                    <div className="form-group">
                      <label>
                        Email<span className="text-danger"> *</span>
                      </label>
                      <Field
                        type="text"
                        className="form-control"
                        name="email"
                        value={values.email}
                        onChange={(e) => {
                          setFieldValue("email", e.target.value);
                          this.setState({ unauthorized: false });
                        }}
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="invalid-feedback"
                        style={{ display: "block" }}
                      />
                      {this.state.unauthorized && (
                        <label
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        >
                          User already exists as a buyer.
                        </label>
                      )}
                    </div>
                    <Button
                      variant="primary"
                      size="sm"
                      className="btn-blue w-140"
                      type="submit"
                      onClick={() => {
                        this.setState({ saveType: "next" }, () => {
                          this.next(values.email, values.role, errors);
                        });
                      }}
                    >
                      Next
                    </Button>
                  </>
                )} */}

                {this.state.page === 1 && (
                  <>
                    <div className="form-group">
                      <label>
                        Email<span className="text-danger"> *</span>
                      </label>
                      <Field
                        type="text"
                        className="form-control"
                        name="email"
                        value={values.email}
                        handleChange={handleChange}
                        onBlur={(e) => {
                          this.getExistingUserData(e.target.value, errors);
                        }}
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="invalid-feedback"
                        style={{ display: "block" }}
                      />
                      {this.state.unauthorized ? (
                        <div
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        >
                          {message.USER_EXISTS}
                        </div>
                      ) : (
                        this.state.sameContingency && (
                          <div
                            className="invalid-feedback"
                            style={{ display: "block" }}
                          >
                            {message.CONTACT_WITH_ROLE_ALREADY_EXISTS}
                          </div>
                        )
                      )}
                    </div>

                    <div className="form-group">
                      <label>
                        First Name<span className="text-danger"> *</span>
                      </label>
                      <Field
                        type="text"
                        name="firstname"
                        className="form-control field_ucfirst"
                        value={values.firstname}
                        disabled={this.state.isEmailValid}
                        handleChange={handleChange}
                      />
                      {this.state.saveType !== "next" && (
                        <ErrorMessage
                          name="firstname"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      )}
                    </div>
                    <div className="form-group">
                      <label>
                        Last Name<span className="text-danger"> *</span>
                      </label>
                      <Field
                        type="text"
                        name="lastname"
                        className="form-control field_ucfirst"
                        value={values.lastname}
                        disabled={this.state.isEmailValid}
                        handleChange={handleChange}
                      />
                      {this.state.saveType !== "next" && (
                        <ErrorMessage
                          name="lastname"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      )}
                    </div>
                    <div className="form-group">
                      <select
                        className="form-control"
                        name="role"
                        value={this.state.role}
                        onChange={(e) => {
                          this.setState({ sameContingency: false });
                          setFieldValue("role", e.target.value);
                        }}
                        style={{ display: "none" }}
                        disabled
                      >
                        <option value="">Select</option>
                        {this.props.roles &&
                          this.props.roles.map((role) => {
                            return (
                              <option key={role._id} value={role._id}>
                                {role.name}
                              </option>
                            );
                          })}
                        <option value="other">Other</option>
                      </select>

                      {this.state.saveType !== "next" && (
                        <ErrorMessage
                          name="role"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      )}
                    </div>
                    {values.role === "other" && (
                      <div className="form-group">
                        <Field
                          type="text"
                          name="other"
                          className="form-control"
                          placeholder="Enter Custom type"
                          required
                          handleChange={handleChange}
                        />
                      </div>
                    )}
                    <div
                      className="form-group"
                      hidden={this.state.isEmailValid}
                    >
                      <label>
                        Mobile Number<span className="text-danger"> *</span>
                      </label>
                      <InputMask
                        mask="999-999-9999"
                        maskChar=""
                        formcontrolprops={{
                          fullWidth: true,
                        }}
                        className="form-control"
                        value={values.mobileNumber}
                        name="mobileNumber"
                        disabled={this.state.isEmailValid}
                        onChange={(e) => {
                          this.setMobile(
                            e.target.value,
                            "mobileNumber",
                            setFieldValue
                          );
                          this.setState({
                            unauthorized: false,
                            mobileUnauthorized: false,
                          });
                        }}
                      >
                        {(inputProps) => <Field {...inputProps} />}
                      </InputMask>
                      {this.state.mobileUnauthorized &&
                        values.mobileNumber != "" && (
                          <label
                            className="invalid-feedback"
                            style={{ display: "block" }}
                          >
                            {message.MOBILE_NUMBER_EXISTS}
                          </label>
                        )}
                      {this.state.saveType !== "next" && (
                        <ErrorMessage
                          name="mobileNumber"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      )}
                    </div>
                    {this.props.roleForPopup === "Client" && (
                      <div className="form-group">
                        <div className="custom-control custom-checkbox custom-control-inline custom-privacy mt-2">
                          <input
                            value={values.isTextMsgEnabled}
                            type="checkbox"
                            className="custom-control-input green-checkbox"
                            id="isTextMsgEnabled"
                            name="isTextMsgEnabled"
                            onChange={(e) => {
                              setFieldValue(
                                "isTextMsgEnabled",
                                e.target.checked
                              );
                            }}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="isTextMsgEnabled"
                          >
                            Opted In to receive text Messages
                          </label>
                        </div>
                      </div>
                    )}
                    {/* <div className="form-group">
                          <label>Company Name</label>
                          <Field
                            type="text"
                            name="companyName"
                            className="form-control field_ucfirst"
                            value={values.companyName}
                            disabled={this.state.isEmailValid}
                            handleChange={handleChange}
                          />
                          {this.state.saveType !== "next" && (
                            <ErrorMessage
                              name="companyName"
                              component="div"
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            />
                          )}
                        </div> */}
                    {this.props.roleForPopup === "Artist" ? (
                      <div>
                        <Row>
                          <Col xs={6}>
                            <div className="form-group">
                              <div className="form-check">
                                <label className="form-check-label">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    name="allowPublicProfile"
                                    checked={values.allowPublicProfile}
                                    onChange={(e) => {
                                      this.checkPublicScheduling(
                                        values,
                                        setFieldValue,
                                        "allowPublicProfile",
                                        e.target.checked
                                      );
                                    }}
                                  />
                                  Allow Public Profile
                                </label>
                              </div>
                              {this.state.allowPublicProfileUrlErr && (
                                <label
                                  className="invalid-feedback"
                                  style={{ display: "block" }}
                                >
                                  Allow Public Scheduling is active.
                                </label>
                              )}
                            </div>
                          </Col>
                          <Col xs={6}>
                            <div className="form-group">
                              <div className="form-check">
                                <label className="form-check-label">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    name="allowPublicScheduling"
                                    checked={values.allowPublicScheduling}
                                    onChange={(e) => {
                                      this.checkPublicProfileUrl(
                                        values,
                                        setFieldValue,
                                        "allowPublicScheduling",
                                        e.target.checked
                                      );
                                    }}
                                  />
                                  Allow Public Scheduling
                                </label>
                              </div>
                              {this.state.allowPublicSchedulingErr && (
                                <label
                                  className="invalid-feedback"
                                  style={{ display: "block" }}
                                >
                                  Allow Public Profile is not checked.
                                </label>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <label>Choose a Color</label>
                        <Row className="ml-1 mt-2 mb-4">
                          <HexColorPicker
                            color={this.state.contact.color}
                            onChange={(e) => setFieldValue("color", e)}
                            style={{ width: "420px", height: "100px" }}
                          />
                        </Row>
                      </div>
                    ) : (
                      ""
                    )}
                    {this.state.isRoleExist && (
                      <Button
                        variant="primary"
                        size="sm"
                        className="btn-blue w-140"
                        onClick={() => {
                          this.props.onClose();
                        }}
                      >
                        {this.state.isEmailValid ? "Close" : "Add"}
                      </Button>
                    )}
                    {!this.state.isRoleExist && (
                      <Button
                        variant="primary"
                        disabled={this.state.unauthorized}
                        size="sm"
                        className="btn-blue w-140"
                        type="submit"
                        onClick={() => {
                          this.setState({ saveType: "" });
                        }}
                      >
                        {this.state.isEmailValid ? "Save" : "Add"}
                      </Button>
                    )}
                  </>
                )}
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    contactResponse: state.reducer.contactResponse,
    contact: state.reducer.contact,
    roles: state.reducer.roles,
  };
};

export default connect(
  mapStateToProps,
  {
    addContactAction,
    getContactByEmailAction,
    getUserRolesActionNew,
    addUserRolesAction,
    addContactActionNew,
    CheckEmailOrMobileUnique,
    CheckEmailOrMobileUniqueatAddContact,
    addClientAction,
  }
)(CreateContact);
